<template>
  <div class="home">
    <header-component position-relation></header-component>
    <div class="home-body">
      <home-black-board :is-loaded-end="loadingEnd"></home-black-board>
      <home-about></home-about>
      <home-news :news-list="newsList"></home-news>
      <home-videos></home-videos>
      <home-recommendation></home-recommendation>
      <home-message-board></home-message-board>
      <home-f-q-a id="homeFQA"></home-f-q-a>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "../../components/HeaderComponent";
import FooterComponent from "../../components/FooterComponent";
import HomeBlackBoard from "./Components/HomeBlackBoard";
import HomeAbout from "./Components/HomeAbout";
import HomeNews from "./Components/HomeNews";
import HomeVideos from "./Components/HomeVideo";
import HomeRecommendation from "./Components/HomeRecommendation";
import HomeMessageBoard from "./Components/HomeMessageBoard";
import HomeFQA from "./Components/HomeFQA";
import IndexMixin from "@/mixins/index-mixin";
import { fetchNewsList } from "@/apis/news";
import { fetchResourceList } from "@/apis/resource";
import { ResponseModel } from "@/models/response-model";

export default {
  name: "HomeIndex",
  mixins: [IndexMixin],
  components: {
    HomeFQA,
    HomeMessageBoard,
    HomeRecommendation,
    HomeVideos,
    HomeNews,
    HomeAbout,
    HomeBlackBoard,
    FooterComponent,
    HeaderComponent,
  },
  data() {
    return {
      loadingEnd: true,
      newsList: [],
      resourcesList: []
    };
  },
  created() {
    window.scroll(0, 0)
  },
  mounted() {
    this.openLoading()
    console.log("START")
    this.loadData().then(() => {
      this.closeLoading()
      console.log("END")
      this.loadingEnd = true
    })
  },
  methods: {
    async loadData() {
      try {
        // const illustrations = require.context(
        //   '@/assets/img/home/cat',
        //   true
        // )
        // const files = illustrations.keys()
        // const promiseAll =  []
        // for (const i in files) {
        //   require(`../../assets/img/home/cat/${files[i].replace("./", "")}`)
        // }
        // await Promise.all(promiseAll)
        const { newsList } = new ResponseModel(await fetchNewsList()).result
        console.log(newsList)
        const { resourceList } = new ResponseModel(await fetchResourceList()).result
        this.newsList = newsList
        this.resourcesList = resourceList
        // const time = await this.waitAsync(5)
        // console.log(time)
        return Promise.resolve()
      } catch (e) {
        console.log(e)
        return Promise.resolve()
      }
    },
    // Timeout Async
    // waitAsync(second) {
    //   return new Promise((r) => setTimeout(r, second * 1000))
    // },
    // loadImage(url) {
    //   return new Promise((resolve) => {
    //     const img = new Image();
    //     console.log(url.replace("./", "../../assets/img/home/"))
    //     img.onload = function () {
    //       // ... 在圖片載入後要進行的操作 ...
    //       resolve(true)
    //     }
    //     // img.src = require("../../assets/img/home/cat/cat-body.svg")
    //     img.src = require(url.replace("./", "../../assets/img/home/"))
    //   })
    // }
  }
};
</script>

<style lang="scss" scoped>
.home-body {
  margin-top: -98px;
}
</style>

<style lang="scss">
</style>
